import { render, staticRenderFns } from "./ReturnLabManager.vue?vue&type=template&id=7967f0ec&scoped=true&"
import script from "./ReturnLabManager.vue?vue&type=script&lang=js&"
export * from "./ReturnLabManager.vue?vue&type=script&lang=js&"
import style0 from "./ReturnLabManager.vue?vue&type=style&index=0&id=7967f0ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7967f0ec",
  null
  
)

export default component.exports